import React, { useEffect, useState } from 'react';
import {
  RiCheckboxCircleLine,
  RiCheckboxBlankCircleLine,
} from 'react-icons/ri';

const RecomendHotels = ({ recomend, onChoose }) => {
  const [checked, setChecked] = useState(recomend);

  useEffect(() => {
    setChecked(recomend);
  }, [recomend]);
  return (
    <button
      className={`hotels__recomend-filter ${
        checked ? 'hotels__recomend-filter_active' : ''
      }`}
      onClick={() => {
        onChoose(!checked);
        setChecked(!checked);
      }}
      title="Отфильтровать рекомендуемые нами отели"
    >
      <span>Рекомендуемые отели</span>
      {checked ? <RiCheckboxCircleLine /> : <RiCheckboxBlankCircleLine />}
    </button>
  );
};
export default RecomendHotels;
